import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const supportRoutes: RouteRecordRaw[] = [
  {
    path: routes.HELP,
    name: 'HELP',
    component: () => import('./HelpPage.vue'),
    meta: { requiresAuth: true },
  },
]
